import {authAxios} from "./axiosClient";
import {listOTURL, listOTViewURL, changeStatusOTURL, listOTHRURL, changeStatusOTHRURL, listOTDacBietURL} from "../constants";

export const GetDataOvertimeApi = (params={})=>{
    const url = listOTViewURL; // 141024 thay cho listOTURL
    return authAxios().get(url,{params})
}

export const GetDataOvertimeHRApi = (params={})=>{
    const url = listOTHRURL;
    return authAxios().get(url,{params})
}

export const SubmitDataOvertimeHRApi = (params={})=>{
    const url = listOTHRURL;
    return authAxios().put(url,params)
}

export const TaoLichOTApi = (params={})=>{
    const url = listOTURL;
    return authAxios().post(url,params);
}

export const EditLichOTApi = (params={})=>{
    const url = listOTURL;
    return authAxios().put(url,params);
}

export const DeleteItemOTApi = (params={})=>{
    const url = listOTURL;
    return authAxios().delete(url,{data:params});
}

export const changeStatusOTApi = (params={})=>{
    const url = changeStatusOTURL;
    return authAxios().put(url,params);
}

export const changeStatusOTHRApi = (params={})=>{
    const url = changeStatusOTHRURL;
    return authAxios().put(url,params);
}

export const GetOTSpecialApi = (params={})=>{
    const url = listOTDacBietURL;
    return authAxios().get(url,{params})
}

